import collection from "./collection";
import set from "./set";
import contact from "./contact";
import payment from "./payment";
import swapForex from "./swapForex";

export default [collection, swapForex, payment, contact, set];
